import { useEffect, useState } from "react";
import "../App.css";
import CategoriesGrid from "../Components/CategoriesGrid";
import WhyChooseUs from "../Components/WhyChooseUs";

import HomeSlider1 from "../image/HomeSlider1.webp";
import HomeSlider2 from "../image/HomeSlider2.webp";
import HomeSlider3 from "../image/HomeSlider3.webp";
import AboutUsSection from "../image/AboutUsSection.webp";
import BedCupboardShowcase from "../image/BedCupboardShowcase.webp";

import LuxuryImage1 from "../image/LuxuryImage1.webp";
import ManufacturingUnit from "../image/ManufacturingUnit.webp";

function Homepage() {
  const [slides] = useState([
    {
      id: 1,
      image: HomeSlider1,
    },
    {
      id: 2,
      image: HomeSlider2,
    },
    {
      id: 3,
      image: HomeSlider3,
    }
  ]);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const intervalId = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 4000);
    return () => clearInterval(intervalId);
  }, [slides]);



  return (
    <>
      {/* Hero Section */}
      <section className="home-hero-section">
        <div className="hero-slider-wrapper">
          {slides.length > 0 ? (
            slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`hero-slide ${index === activeIndex ? "active" : ""}`}
              >
                <img
                  src={slide.image}
                  alt={slide.name || `Slider ${index + 1}`}
                  className="hero-slide-image"
                  loading={index === 0 ? "eager" : "lazy"}
                />
              </div>
            ))
          ) : (
            <div className="hero-slide hero-slide-empty active" />
          )}
        </div>
      </section>

      {/* About Section - One Stop Solution */}
      <section className="section-padding light-section" id="about">
        <div className="container position-relative z-1">
          <div className="row align-items-center flex-column-reverse flex-md-row">
            <div className="col-12 col-md-6 mt-4 mt-md-0 pe-md-4 pe-lg-5 text-center text-md-start">
              <span className="section-pill mb-3">About Shree Kamdhenu Furniture</span>
              <h2 className="section-heading text-dark mb-3 mb-md-4 fs-3 fs-md-2">One Stop <span className="text-primary fst-italic">Solution</span></h2>
              <p className="text-muted-dark mb-4 fs-6 px-2 px-md-0" style={{ lineHeight: '1.8' }}>
                Shree Kamdhenu Furniture (Khodiyar Fabrication) is a trusted manufacturer of premium steel beds, designer box beds, laser CNC cupboards, and heavy-duty almirahs. We are committed to delivering top-quality steel furniture that forms the foundation of strong, stylish, and long-lasting spaces.
              </p>
              <a href="/about" className="btn btn-primary rounded-pill px-4 py-2 mt-2 mt-md-3">View More &rarr;</a>
            </div>
            <div className="col-12 col-md-6 text-center position-relative mb-4 mb-md-0">
              <div className="about-image-card white-card p-2 p-sm-3 p-md-3 mx-auto rounded-4 position-relative z-1" style={{ maxWidth: '100%', margin: '0 auto' }}>
                <img src={AboutUsSection} alt="Furniture" className="img-fluid rounded-3 shadow-sm w-100" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Collections Section */}
      <section className="section-padding dark-section" id="collections" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="container text-center position-relative z-1">
          <span className="section-pill mb-3">Style Spotlight</span>
          <h2 className="section-heading text-white mb-4 mb-md-5 fs-3 fs-md-2">Our <span className="text-primary fst-italic">Collections</span></h2>

          <CategoriesGrid />
        </div>
      </section>

      {/* Why Choose Us Section */}
      <WhyChooseUs />

      {/* Stats Banner */}
      <section className="stats-banner py-4 py-md-5" style={{
        background: `linear-gradient(rgba(198, 40, 40, 0.85), rgba(198, 40, 40, 0.95)), url(${ManufacturingUnit})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container position-relative z-1">
          <div className="row align-items-center">
            <div className="col-lg-5 text-center text-lg-start mb-4 mb-lg-0">
              <h3 className="text-white font-serif mb-3 fs-4 fs-md-3">"Your Project Starts Here."</h3>
              <p className="text-white opacity-75 mb-4">Have a project in mind?</p>
              <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20your%20furniture%20and%20products." target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-pill px-4 py-2 hover-lift">Inquiry Now</a>
            </div>
            <div className="col-lg-7 mb-0">
              <div className="row text-center border border-light border-opacity-25 p-3 p-md-4 rounded-4" style={{ background: 'rgba(0,0,0,0.1)' }}>
                <div className="col-4 border-end border-light border-opacity-25">
                  <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">32+</h2>
                  <p className="text-white opacity-75 small mb-0 fs-7">Years Of Experience</p>
                </div>
                <div className="col-4 border-end border-light border-opacity-25">
                  <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">99%</h2>
                  <p className="text-white opacity-75 small mb-0 fs-7">Client Satisfied</p>
                </div>
                <div className="col-4">
                  <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">500+</h2>
                  <p className="text-white opacity-75 small mb-0 fs-7">Happy Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Discover Premium Steel Beds & Cupboards Section */}
      <section className="section-padding text-center position-relative" style={{
        background: `linear-gradient(rgba(15, 23, 42, 0.75), rgba(15, 23, 42, 0.9)), url(${LuxuryImage1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="glowing-orb primary top-0 start-50 translate-middle-x" style={{ width: '400px', height: '400px' }}></div>
        <div className="container position-relative z-1">
          <h2 className="font-serif text-white display-6 display-md-5 fw-bold mb-3">Premium Steel Beds<br />& Designer Cupboards</h2>
          <p className="text-light opacity-75 mx-auto px-2 px-md-0" style={{ maxWidth: '600px' }}>
            At Shree Kamdhenu Furniture, we deliver high-grade ISI steel beds, cushion beds, laser cut cupboards, and dressing almirahs that combine heavy-duty strength, long durability, and modern design.
          </p>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section-padding light-section">
        <div className="container text-center position-relative z-1">
          <span className="section-pill mb-3">Testimonials</span>
          <h2 className="section-heading text-dark mb-3 mb-md-4 fs-3 fs-md-2">Quality That <span className="text-primary fst-italic">Our Clients Speak For</span></h2>
          <p className="text-muted-dark mx-auto mb-4 mb-md-5 px-2 px-md-0" style={{ maxWidth: '700px' }}>
            Our clients' words reflect our commitment to quality, craftsmanship, and reliable service. Every bed and cupboard we deliver is built on trust, precision, and satisfaction.
          </p>

          <div className="row g-3 g-md-4 justify-content-center">
            {[
              { name: "Manish Ghoghari", text: "Shree Kamdhenu provided premium quality steel beds and excellent cupboard fitting." },
              { name: "Sneha Enterprise", text: "The quality and laser finish on the cupboards exceeded our expectations. Highly recommended." },
              { name: "Vivek Savaliya", text: "Strong steel materials, modern bed designs & timely delivery made our purchase great." }
            ].map((review, i) => (
              <div key={i} className="col-12 col-md-6 col-lg-4">
                <div className="testimonial-card white-card p-3 p-md-4 rounded-4 text-start h-100 position-relative transition-all hover-lift d-flex flex-column">
                  <div className="quote-icon text-primary opacity-25 position-absolute top-0 end-0 p-3" style={{ fontSize: '3rem' }}>"</div>
                  <p className="text-muted-dark fst-italic mb-4 position-relative z-1 flex-grow-1" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>{review.text}</p>
                  <div className="d-flex align-items-center gap-3 mt-auto">
                    <div className="avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: '45px', height: '45px', flexShrink: 0 }}>
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-warning small mb-1" style={{ letterSpacing: '2px' }}>★★★★★</div>
                      <h6 className="mb-0 fw-bold text-dark" style={{ fontSize: '0.95rem' }}>{review.name}</h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Floating 3D Showcase Section for Beds & Cupboards */}
      <section className="premium-showcase-section position-relative py-5 overflow-hidden text-center" style={{ background: 'linear-gradient(135deg, #0A1C40 0%, #1a0a10 100%)' }}>
        {/* Huge glowing orb in background */}
        <div className="position-absolute top-50 start-50 translate-middle rounded-circle" style={{ width: '60vw', height: '60vw', background: 'radial-gradient(circle, rgba(168,28,28,0.3) 0%, rgba(10,28,64,0) 70%)', filter: 'blur(60px)', zIndex: 0 }}></div>

        <div className="container position-relative z-1 py-2 py-md-4">
          <h6 className="text-light fw-bold text-uppercase mb-3" style={{ letterSpacing: '4px', opacity: 0.8 }}>Masterpiece Craftsmanship</h6>
          <h2 className="font-serif text-white mb-4 mb-md-5 display-5 display-md-4" style={{ fontWeight: '700' }}>
            Built for <span className="text-primary fst-italic">Strength & Elegance</span>
          </h2>

          {/* The Image with Floating Glass Pills */}
          <div className="position-relative mx-auto mt-4" style={{ maxWidth: '900px' }}>

            {/* Floating Pill 1: Top Left */}
            <div className="position-absolute d-none d-md-flex align-items-center gap-2 glass-pill-feature" style={{ top: '15%', left: '-5%', zIndex: 3, animationDelay: '0s' }}>
              <div className="bg-primary rounded-circle" style={{ width: '10px', height: '10px' }}></div>
              <span className="fw-bold tracking-widest small text-white">TATA & Jindal Steel</span>
            </div>

            {/* Floating Pill 2: Bottom Left */}
            <div className="position-absolute d-none d-md-flex align-items-center gap-2 glass-pill-feature" style={{ bottom: '25%', left: '5%', zIndex: 3, animationDelay: '1s' }}>
              <div className="bg-primary rounded-circle" style={{ width: '10px', height: '10px' }}></div>
              <span className="fw-bold tracking-widest small text-white">Laser CNC Art Finish</span>
            </div>

            {/* Floating Pill 3: Top Right */}
            <div className="position-absolute d-none d-md-flex align-items-center gap-2 glass-pill-feature" style={{ top: '30%', right: '-5%', zIndex: 3, animationDelay: '0.5s' }}>
              <div className="bg-primary rounded-circle" style={{ width: '10px', height: '10px' }}></div>
              <span className="fw-bold tracking-widest small text-white">Heavy Inside Bolt Fitting</span>
            </div>

            {/* Showcase Image */}
            <img
              src={BedCupboardShowcase}
              alt="Shree Kamdhenu Beds & Cupboards Showcase"
              className="img-fluid rounded-4"
              style={{
                position: 'relative',
                zIndex: 2,
                filter: 'drop-shadow(0px 30px 40px rgba(0,0,0,0.6))'
              }}
            />

            {/* Shadow Base */}
            <div className="mx-auto d-none d-md-block" style={{ width: '70%', height: '20px', background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 70%)', marginTop: '-10px', zIndex: 1, position: 'relative' }}></div>
            <div className="mx-auto d-block d-md-none" style={{ width: '90%', height: '10px', background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 70%)', marginTop: '-5px', zIndex: 1, position: 'relative' }}></div>

            {/* Mobile Features List */}
            <div className="d-flex d-md-none flex-wrap justify-content-center gap-2 mt-4 position-relative z-3 px-2">
              <div className="glass-pill-feature d-flex align-items-center gap-2 px-3 py-2" style={{ animation: 'none' }}>
                <div className="bg-primary rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                <span className="fw-bold tracking-widest text-white" style={{ fontSize: '0.75rem' }}>TATA & Jindal Steel</span>
              </div>
              <div className="glass-pill-feature d-flex align-items-center gap-2 px-3 py-2" style={{ animation: 'none' }}>
                <div className="bg-primary rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                <span className="fw-bold tracking-widest text-white" style={{ fontSize: '0.75rem' }}>Laser CNC Finish</span>
              </div>
              <div className="glass-pill-feature d-flex align-items-center gap-2 px-3 py-2" style={{ animation: 'none' }}>
                <div className="bg-primary rounded-circle" style={{ width: '8px', height: '8px' }}></div>
                <span className="fw-bold tracking-widest text-white" style={{ fontSize: '0.75rem' }}>Heavy Inside Bolt</span>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mt-4 mt-md-5">
            <div className="col-lg-7 px-3 px-md-4">
              <p className="text-light fs-6 fs-md-5 mb-4 mb-md-5 mx-auto" style={{ lineHeight: '1.8', opacity: 0.8, maxWidth: '600px' }}>
                Every bend, MIG welding joint, and laser cut design is crafted with precision. Bring home strong, elegant beds and cupboards built for lifetime reliability.
              </p>
              <a href="/collections" className="btn btn-outline-light rounded-pill px-4 px-md-5 py-2 py-md-3 text-uppercase fw-bold transition-all shadow hover-lift" style={{ letterSpacing: '1px' }}>
                View Full Collection
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Homepage;
